<style src="./MonthEvents.scss" lang="scss"></style>
<template>
  <section class="month-events">
    <div class="lateral">
      <span class="title">{{ textAbrevMonth }} / {{ year }}</span>
    </div>
    
    <div class="info">
      <div class="participation">
        <div class="participated">
          <span class="title">PARTICIPAÇÕES</span>
          <span class="value">
          {{ monthParticipated }}
          <small class="perc perc__info">{{ participatedPerc }}%</small>
        </span>
        </div>
        <div class="participated">
          <span class="title">NÃO PARTICIPAÇÕES</span>
          <span class="value">
          {{ monthNotParticipated }}
          <small class="perc perc__danger">{{ notParticipatedPerc }}%</small>
        </span>
        </div>
      </div>
      <div class="total">
        <span class="counttotal">
          {{ countTotal }}
        </span>
        <span>EVENTOS EM {{ textMonth }}</span>
      </div>
    </div>
  </section>
</template>

<script>
const MONTHS = ['JANEIRO', 'FEVEREIRO', 'MARÇO', 'ABRIL', 'MAIO', 'JUNHO', 'JULHO', 'AGOSTO', 'SETEMBRO', 'OUTUBRO', 'NOVEMBRO', 'DEZEMBRO']

export default {
  name: 'MonthEvents',
  props: {
    month: {
      default: null
    },
    year: {
      default: null
    },
    monthParticipated: {
      default: null
    },
    monthNotParticipated: {
      default: null
    }
  },
  computed: {
    countTotal () {
      return Number(this.monthParticipated) + Number(this.monthNotParticipated)
    },
    textAbrevMonth () {
      return MONTHS[Number(this.month) - 1].substring(0, 3)
    },
    textMonth () {
      return MONTHS[Number(this.month) - 1]
    },
    participatedPerc () {
      if (!this.monthParticipated) { return 0 }
      const p = this.monthParticipated
      const r = ((p * 100) / this.countTotal).toFixed()
      return r
    },
    notParticipatedPerc () {
      if (!this.monthNotParticipated) { return 0 }
      const p = this.monthNotParticipated
      const r = ((p * 100) / this.countTotal).toFixed()
      return r
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/dashboard/components/month-events/MonthEvents.vue